(function (doc, win) {
    let rafId;
    const designSize = 1920;
    
    function setRootFontSize() {
        const docElem = doc.documentElement;
        const screenW = docElem.clientWidth || doc.body.clientWidth;
        const size = screenW <= 375 ? 375 : screenW <= designSize ? designSize : screenW;
        const fontSize = `${16 / (designSize / size)}px`;
    
        if (fontSize !== docElem.style.fontSize) {
            docElem.style.fontSize = fontSize;
        }
    }
    function onResize() {
        if (rafId) {
            cancelAnimationFrame(rafId);
        }
        rafId = requestAnimationFrame(setRootFontSize);
    }
    setRootFontSize();
    if ('addEventListener' in doc) {
        win.addEventListener(
            'orientationchange' in win ? 'orientationchange' : 'resize',
            onResize,
            false,
        );
    }
})(document, window)